import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import BpcDirectDebitFilesTabs from '@accounting/components/tabs/direct-debit-files/direct-debit-files-tabs.vue';

@Component({
  name: 'bpc-direct-debit-files',
  components: {
    'bpc-direct-debit-files-tabs': BpcDirectDebitFilesTabs,
    'bpc-page-title': BpcPageTitle,
  },
})
export default class CreditNotes extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
